import axios from "../services/api/api";

export const ADD_PRODUCT = "ADD_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const FETCH_PRODUCTS_BEGIN = "FETCH_PRODUCTS_BEGIN";
export const FETCH_PRODUCTS_FULFILLED = "FETCH_PRODUCTS_FULFILLED";
export const FETCH_PRODUCTS_REJECTED = "FETCH_PRODUCTS_REJECTED";
export const FETCH_STUDENTS_WITH_LICENSE_NEW_BEGIN =
  "FETCH_STUDENTS_WITH_LICENSE_NEW_BEGIN";
export const FETCH_STUDENTS_WITH_LICENSE_NEW_FULFILLED =
  "FETCH_STUDENTS_WITH_LICENSE_NEW_FULFILLED";
export const FETCH_STUDENTS_WITH_LICENSE_NEW_REJECTED =
  "FETCH_STUDENTS_WITH_LICENSE_NEW_REJECTED";

export function addProduct({ id, title, description, price }) {
  return {
    type: ADD_PRODUCT,
    payload: { id, title, description, price },
  };
}
export function updateProduct({ id, title }) {
  return {
    type: UPDATE_PRODUCT,
    payload: { id, title },
  };
}

export function fetchProgramLicenses(school) {
  return function (dispatch) {
    dispatch({ type: "FETCH_PRODUCTS_BEGIN", payload: { loading: true } });
    axios
      .get(`/ShopNew/GetLicenses?schoolId=${school.id}`)
      .then((response) => {
        dispatch({
          type: "FETCH_PRODUCTS_FULFILLED",
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: "FETCH_PRODUCTS_REJECTED", payload: err });
      });
  };
}

export function fetchStudentsWithLicenseNew(school) {
  return function (dispatch) {
    dispatch({
      type: "FETCH_STUDENTS_WITH_LICENSE_NEW_BEGIN",
      payload: { loading: true },
    });
    axios
      .get(`/ShopNew/LicenseStatusForStudents?schoolId=${school.id}`)
      .then((response) => {
        dispatch({
          type: "FETCH_STUDENTS_WITH_LICENSE_NEW_FULFILLED",
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({
          type: "FETCH_STUDENTS_WITH_LICENSE_NEW_REJECTED",
          payload: err,
        });
      });
  };
}

export function fetchLicense(schoolName) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/School/License`, {
        Name: schoolName,
      })
      .then((response) => {
        return resolve(response.data.result);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
